import React, { useRef, useState, useContext } from "react";
import styled from "styled-components";
import { Link, useLocation, Navigate } from "react-router-dom";

import EmailIcon from "@mui/icons-material/Email";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

import { HeadingOne } from "../../theme";
import { AuthContext } from "../authContextProvider";
import { getTranslation, LanguageContext } from "../languageProvider";
import { SignIn } from "../../firebase";
import { Log, selectNextOnEnter, UpdateInputChange } from "../shared/utility";
import { LayoutLogin } from "../layout/loginPage";
import AccountNotActivated from "./accountNotActivated";
import FormHooks from "../shared/formHooks";

export const Login = () => {
  const emailRef = useRef();
  const passwordRef = useRef();
  const submitRef = useRef();

  const { state } = useLocation();

  const { user, appUser, userVerified, snackbarHandler, setAuthLoading } =
    useContext(AuthContext);
  const { lang } = useContext(LanguageContext);

  const [formInputs, setFormInputs] = useState({
    email: {
      type: "input",
      label: "0002",
      icon: <EmailIcon />,
      value: "",
      validation: {
        required: true,
      },
      valid: false,
      touched: false,
      inputRef: emailRef,
      input: {
        type: "email",
        onKeyDown: (e) => selectNextOnEnter(e, passwordRef),
      },
    },
    password: {
      type: "password",
      label: "0003",
      icon: null,
      value: "",
      validation: {
        required: true,
        min: 6,
      },
      valid: false,
      touched: false,
      inputRef: passwordRef,
      input: {
        type: "password",
        id: "password",
        autoComplete: "password-off",
        onKeyDown: (e) => selectNextOnEnter(e, submitRef),
      },
    },
    submit: {
      type: "submit",
      icon: <ExitToAppIcon />,
      text: "0001",
      inputRef: submitRef,
      isSubmit: true,
      className: "btn-secondary",
      clicked: (e) => loginSubmitHandler(e),
      valid: false,
    },
  });

  const inputChangeHandler = (e, key) =>
    setFormInputs(UpdateInputChange(formInputs, e.target.value, key));

  const loginSubmitHandler = (e) => {
    if (formInputs.submit.valid) {
      e.preventDefault();
      let email = emailRef.current.value;
      let password = passwordRef.current.value;

      SignIn(email, password)
        .then(() => setAuthLoading(true))
        .catch(() => {
          Log("error on login");
          snackbarHandler(getTranslation(`0083`));
        });
    }
  };
  if (user && appUser) {
    return <Navigate to={state ? state.from : "/dashboard"} />;
  } else {
    if (!userVerified) return <AccountNotActivated />;
    return (
      <LayoutLogin lang={lang}>
        <LoginBox>
          <HeadingOne marginBottom={30} textCenter data-translate="0001">
            {getTranslation("0001")}
            {process.env.REACT_APP_NODE_ENV === "development" && (
              <span data-translate="0089">{getTranslation("0089")}</span>
            )}
          </HeadingOne>
          <FormHooks
            formInputs={formInputs}
            inputChange={inputChangeHandler}
            onSubmit={loginSubmitHandler}
            size="md"
            layout="outline"
            hideError={true}
          />
          <Link to="/forgotPassword" data-translate="0004">
            {getTranslation("0004")}
          </Link>
        </LoginBox>
      </LayoutLogin>
    );
  }
};

export const LoginBox = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
      border:1px solid rgba(${current.black}, 0.0625);
      background:rgb(${current.white});
      padding:${current.gMD};
      padding-top:${current.gLG};
      width:350px;
      border-radius:4px;
      margin-bottom:${current.gMD};
      text-align:center;
      >p{
        padding:${current.gLG};
        text-align:center;
      }
      form{
        margin-bottom:${current.gLG};
      }
      >a{
        color:rgb(${current.cTwo});
        :hover{
          color:rgb(${current.blueGray});
        }
      }
    `;
  }}
`;
